import axios from '@utils/axiosInstance'
import queryStringFilterBuilder from '@utils/queryStringFilterBuilder'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

export const state = {
  events: [],
  collaboratorEvents: [],
  collaboratorEventsOriginal: [],
  collaboratorsWithEvents: null,
  hourTypologies: JSON.parse(localStorage.getItem('hourTypologies'))
      ? JSON.parse(localStorage.getItem('hourTypologies'))
      : [],
  hourTypologiesPlanningTemplate: JSON.parse(
      localStorage.getItem('hourTypologiesPlanningTemplate'),
  )
      ? JSON.parse(localStorage.getItem('hourTypologiesPlanningTemplate'))
      : [],
  hourTypology: null,
  planningRule: null,
  planningRules: [],
  groupingType: null,
  groupingTypes: [],
  siteCex: [],
  hourParents: [],
  planningTemplate: [],
  planningTemplatePeriods: [],
  collaboratorTeamWeekPlanning: [],
  collaboratorWeekPlanning: [],
  templateManagementWeeks: null,
  siteQuarterlyNotifications: null,
  teamQuarterlyNotifications: null,
  collaboratorQuarterlyNotification: null,
  signedQuarterlyNotification: null,
  collaboratorsWithPendingNotifications: [],
  weeklyNotifications: [],
  managedWeeklyNotifications: [],
  collaboratorWeeklyNotification: null,
  signWeeklyNotificationDocument: null,
  collaboratorsWithPendingWeeklyNotifications: [],
  legalErrors: [],
  quarterlyNotificationSignDate: null,
  collaboratorPlanningDifferences: {
    startWorkingTime: null,
    weekNumber: null,
    differences: [],
    weekDates: [],
    collaborator: null,
    team: null,
  },
  collaboratorWeekPlanningModificationDifferences: [],
  teamWeekPlanningEvents: [],
  collaboratorPendingWeeklyNotifications: [],
  pendingQuarterlyNotificationCollaborator: [],
  defaultTimeSlots: [],
  siteTimeSlotsIntervals: [],
  siteTimeSlotsInterval: null,
  activeSiteTimeSlots: [],
  collaboratorData: null,
}

export const getters = {}

export const mutations = {
  UPDATE_EVENTS(state, events) {
    state.events = events
  },
  UPDATE_HOUR_TYPOLOGY(state, hourTypology) {
    state.hourTypology = hourTypology
  },
  RESET_HOUR_TYPOLOGY(state) {
    state.hourTypology = null
  },
  UPDATE_HOUR_TYPOLOGIES(state, hourTypologies) {
    localStorage.setItem('hourTypologies', JSON.stringify(hourTypologies))
    state.hourTypologies = hourTypologies
  },
  UPDATE_HOUR_TYPOLOGIES_PLANNING_TEMPLATE(
      state,
      hourTypologiesPlanningTemplate,
  ) {
    localStorage.setItem(
        'hourTypologiesPlanningTemplate',
        JSON.stringify(hourTypologiesPlanningTemplate),
    )
    state.hourTypologiesPlanningTemplate = hourTypologiesPlanningTemplate
  },
  RESET_PLANNING_RULE(state) {
    state.planningRule = null
  },
  UPDATE_PLANNING_RULE(state, planningRule) {
    state.planningRule = planningRule
  },
  UPDATE_PLANNING_RULES(state, planningRules) {
    state.planningRules = planningRules
  },
  UPDATE_PLANNING_GROUPING_TYPE(state, groupingType) {
    state.groupingType = groupingType
  },
  UPDATE_PLANNING_GROUPING_TYPES(state, groupingTypes) {
    state.groupingTypes = groupingTypes
  },
  UPDATE_SITE_CEX(state, siteCex) {
    state.siteCex = siteCex
  },
  UPDATE_HOUR_PARENTS(state, hourParents) {
    state.hourParents = hourParents
  },
  UPDATE_PLANNING_TEMPLATE(state, planningTemplate) {
    state.planningTemplate = planningTemplate
  },
  UPDATE_PLANNING_TEMPLATE_PERIODS(state, planningTemplate) {
    state.planningTemplatePeriods = formatTemplatePeriods(planningTemplate)
  },
  UPDATE_TEAM_WEEK_PLANNING(state, teamWeekPlanning) {
    state.events = formatModificationProposal(teamWeekPlanning)
  },
  UPDATE_COLLABORATOR_TEAM_WEEK_PLANNING(state, collaboratorTeamWeekPlanning) {
    state.collaboratorTeamWeekPlanning = collaboratorTeamWeekPlanning
  },
  UPDATE_COLLABORATOR_WEEK_PLANNING(state, collaboratorWeekPlanning) {
    state.collaboratorWeekPlanning = collaboratorWeekPlanning
  },
  UPDATE_TEAM_WEEK_MODIFICATION_PROPOSAL(state, teamWeekModificationProposal) {
    state.events = formatModificationProposal(teamWeekModificationProposal)
  },
  RESET_COLLABORATOR_EVENTS(state) {
    state.collaboratorEvents = null
  },
  UPDATE_COLLABORATOR_MONTH_PLANNING_MANAGER(state, collaboratorEvents) {
    state.collaboratorEvents = filterCollaboratorMonthPlanningManager(collaboratorEvents)
    state.collaboratorEventsOriginal = formatCollaboratorMonthPlanningEvents(collaboratorEvents)
  },
  UPDATE_COLLABORATOR_BASIC_DATA(state, collaboratorData) {
    state.collaboratorData = collaboratorData
  },
  UPDATE_COLLABORATOR_MONTH_PLANNING(state, collaboratorEvents) {
    state.collaboratorEvents = formatCollaboratorMonthPlanningEvents(collaboratorEvents)
    state.collaboratorEventsOriginal = formatCollaboratorMonthPlanningEvents(collaboratorEvents)
  },
  UPDATE_TEMPLATE_MANAGEMENT_WEEKS(state, templateManagementWeeks) {
    state.templateManagementWeeks = templateManagementWeeks
  },
  UPDATE_SITE_QUARTERLY_NOTIFICATIONS(state, siteQuarterlyNotifications) {
    state.siteQuarterlyNotifications = siteQuarterlyNotifications
  },
  UPDATE_TEAM_QUARTERLY_NOTIFICATIONS(state, teamQuarterlyNotifications) {
    state.teamQuarterlyNotifications = teamQuarterlyNotifications
  },
  UPDATE_COLLABORATOR_QUARTERLY_NOTIFICATIONS(
    state,
    collaboratorQuarterlyNotification,
  ) {
    state.collaboratorQuarterlyNotification = filterCollaboratorMonthPlanning(
      collaboratorQuarterlyNotification,
    )
  },
  UPDATE_SIGNED_QUARTERLY_NOTIFICATION(state, signedQuarterlyNotification) {
    state.signedQuarterlyNotification = filterCollaboratorMonthPlanning(
      signedQuarterlyNotification,
    )
  },
  UPDATE_QUARTERLY_NOTIFICATIONS_SIGN_DATE(
    state,
    quarterlyNotificationSignDate,
  ) {
    state.quarterlyNotificationSignDate = quarterlyNotificationSignDate
  },
  UPDATE_COLLABORATORS_WITH_PENDING_NOTIFICATIONS(
    state,
    collaboratorsWithPendingNotifications,
  ) {
    state.collaboratorsWithPendingNotifications =
      collaboratorsWithPendingNotifications
  },
  UPDATE_WEEKLY_NOTIFICATIONS(state, weeklyNotifications) {
    state.weeklyNotifications = weeklyNotifications
  },
  UPDATE_MANAGED_WEEKLY_NOTIFICATIONS(state, managedWeeklyNotifications) {
    state.managedWeeklyNotifications = managedWeeklyNotifications
  },
  UPDATE_COLLABORATOR_WEEKLY_NOTIFICATIONS(
    state,
    collaboratorWeeklyNotification,
  ) {
    state.collaboratorWeeklyNotification = collaboratorWeeklyNotification
  },
  UPDATE_LEGAL_ERRORS(state, legalErrors) {
    state.legalErrors = legalErrors
  },
  RESET_PENDING_QUARTERLY_NOTIFICATION_FOR_COLLABORATOR() {
    state.pendingQuarterlyNotificationCollaborator = []
  },
  UPDATE_PENDING_QUARTERLY_NOTIFICATION_FOR_COLLABORATOR(
    state,
    pendingQuarterlyNotificationCollaborator,
  ) {
    state.pendingQuarterlyNotificationCollaborator.push(
      pendingQuarterlyNotificationCollaborator,
    )
  },
  UPDATE_QUARTERLY_NOTIFICATIONS_BY_COLLABORATOR(
      state,
      viewQuarterlyNotificationCollaborator,
  ) {
    state.collaboratorQuarterlyNotification =
        formatCollaboratorMonthPlanningEvents(
            viewQuarterlyNotificationCollaborator.proposals,
        )
  },
  UPDATE_COLLABORATOR_PLANNING_DIFFERENCES(
      state,
      collaboratorPlanningDifferences,
  ) {
    state.collaboratorPlanningDifferences = collaboratorPlanningDifferences
  },
  UPDATE_COLLABORATOR_PENDING_WEEKLY_NOTIFICATIONS(
    state,
    collaboratorPendingWeeklyNotifications,
  ) {
    state.collaboratorPendingWeeklyNotifications =
      collaboratorPendingWeeklyNotifications
  },
  UPDATE_COLLABORATOR_WEEK_PLANNING_MODIFICATION_DIFFERENCES(
      state,
      collaboratorWeekPlanningModificationDifferences,
  ) {
    state.collaboratorWeekPlanningModificationDifferences =
        formatCollaboratorWeekPlanningModificationDifferences(
            collaboratorWeekPlanningModificationDifferences,
        )
  },
  UPDATE_DEFAULT_TIME_SLOTS(state, defaultTimeSlots) {
    state.defaultTimeSlots = defaultTimeSlots
  },
  UPDATE_SITE_TIME_SLOTS_INTERVALS(state, siteTimeSlotsIntervals) {
    state.siteTimeSlotsIntervals = siteTimeSlotsIntervals
  },
  UPDATE_SITE_TIME_SLOTS_INTERVAL(state, siteTimeSlotsInterval) {
    state.siteTimeSlotsInterval = siteTimeSlotsInterval
  },
  UPDATE_ACTIVE_SITE_TIME_SLOTS(state, activeSiteTimeSlots) {
    state.activeSiteTimeSlots = activeSiteTimeSlots
  },
  // ///////////////
  // TEMPLATE EVENTS
  // ///////////////
  ADD_EVENT_TEMPLATE(state, event) {
    state.planningTemplatePeriods.push(event)
  },
  REMOVE_EVENT_TEMPLATE(state, event) {
    const eventIndex = state.planningTemplatePeriods.findIndex(
        (e) => e.id === event.id,
    )
    state.planningTemplatePeriods.splice(eventIndex, 1)
  },
  UPDATE_EVENT_TEMPLATE(state, payload) {
    const eventToUpdate = getTemplateEventToUpdate(state, payload.event.event)
    eventToUpdate.title = `${Math.abs(
        (eventToUpdate.end - eventToUpdate.start) / 36e5,
    )}h ${payload.hourTypologyData.abbreviation}`
    eventToUpdate.hourTypologyUuid = payload.hourTypologyData.uuid
    eventToUpdate.hourTypology = payload.hourTypologyData.abbreviation
    eventToUpdate.color = payload.hourTypologyData.color
  },
  RESIZE_EVENT_TEMPLATE(state, event) {
    const eventToUpdate = getTemplateEventToUpdate(state, event.event)
    eventToUpdate.title = `${Math.abs(
        (event.event.end - event.event.start) / 36e5,
    )}h ${eventToUpdate.hourTypology}`
    eventToUpdate.start = event.event.startStr
    eventToUpdate.end = event.event.endStr
  },
  DROP_EVENT_TEMPLATE(state, event) {
    const eventToUpdate = getTemplateEventToUpdate(state, event.event)
    eventToUpdate.title = `${Math.abs(
        (event.event.end - event.event.start) / 36e5,
    )}h ${eventToUpdate.hourTypology}`
    eventToUpdate.resourceId = event.newResource
        ? event.newResource.id
        : eventToUpdate.resourceId
    eventToUpdate.start = event.event.startStr
    eventToUpdate.end = event.event.endStr
  },
  // ////////////////
  // TEAM WEEK EVENTS
  // ////////////////
  ADD_EVENT(state, event) {
    state.teamWeekPlanningEvents.push(event)
  },
  UPDATE_EVENT(state, payload) {
    const index = state.teamWeekPlanningEvents.findIndex(
        (_event) => _event.id.toString() === payload.event.id.toString(),
    )
    const eventToUpdate = state.teamWeekPlanningEvents[index]

    eventToUpdate.title = `${Math.abs(
        (eventToUpdate.end - eventToUpdate.start) / 36e5,
    )}h ${payload.hourTypologyData.abbreviation}`
    eventToUpdate.hourTypologyUuid = payload.hourTypologyData.uuid
    eventToUpdate.hourTypology = payload.hourTypologyData.abbreviation
    eventToUpdate.color = payload.hourTypologyData.color
  },
  DROP_EVENT(state, arg) {
    const index = state.teamWeekPlanningEvents.findIndex(
        (_event) => _event.id.toString() === arg.event.id.toString(),
    )
    state.teamWeekPlanningEvents[index].title = `${Math.abs(
        (arg.event.end - arg.event.start) / 36e5,
    )}h ${state.teamWeekPlanningEvents[index].hourTypology}`
    state.teamWeekPlanningEvents[index].resourceId = arg.newResource
        ? arg.newResource.id
        : state.teamWeekPlanningEvents[index].resourceId
    state.teamWeekPlanningEvents[index].start = arg.event.startStr
    state.teamWeekPlanningEvents[index].end = arg.event.endStr
  },
  RESIZE_EVENT(state, arg) {
    const index = state.teamWeekPlanningEvents.findIndex(
        (_event) => _event.id.toString() === arg.event.id.toString(),
    )
    state.teamWeekPlanningEvents[index].title = `${Math.abs(
        (arg.event.end - arg.event.start) / 36e5,
    )}h ${state.teamWeekPlanningEvents[index].hourTypology}`
    state.teamWeekPlanningEvents[index].start = arg.event.startStr
    state.teamWeekPlanningEvents[index].end = arg.event.endStr
  },
  REMOVE_EVENT(state, event) {
    const index = state.teamWeekPlanningEvents.findIndex(
        (_event) => _event.id.toString() === event.id.toString(),
    )
    state.teamWeekPlanningEvents.splice(index, 1)
  },
  EDIT_EVENT(state, hourTypologyData) {
    const index = state.teamWeekPlanningEvents.findIndex(
        (_event) => _event.id === hourTypologyData.event.event.id,
    )
    state.teamWeekPlanningEvents[index].hourTypology =
        hourTypologyData.hourTypology
    state.teamWeekPlanningEvents[index].color = hourTypologyData.eventColor
    state.teamWeekPlanningEvents[index].title = `${Math.abs(
        (hourTypologyData.event.event.end - hourTypologyData.event.event.start) /
        36e5,
    )}h ${hourTypologyData.hourTypology}`
  },
  // /////////////////////////
  // COLLABORATOR MONTH EVENTS
  // /////////////////////////
  ADD_EVENT_COLLABORATOR(state, event) {
    state.collaboratorEvents.push(event)
  },
  REMOVE_EVENT_COLLABORATOR(state, event) {
    const index = state.collaboratorEvents.findIndex((_event) => {
      return _event.id === event.id
    })
    state.collaboratorEvents.splice(index, 1)
  },
  UPDATE_EVENT_COLLABORATOR(state, payload) {
    const index = state.collaboratorEvents.findIndex((_event) => {
      return _event.id === payload.event.id
    })
    const eventToUpdate = state.collaboratorEvents[index]

    eventToUpdate.title = `${Math.abs(
        (eventToUpdate.end - eventToUpdate.start) / 36e5,
    )}h ${payload.hourTypologyData.abbreviation}`
    eventToUpdate.hourTypologyUuid = payload.hourTypologyData.uuid
    eventToUpdate.hourTypology = payload.hourTypologyData.abbreviation
    eventToUpdate.color = payload.hourTypologyData.color
  },
  DROP_EVENT_COLLABORATOR(state, arg) {
    const index = state.collaboratorEvents.findIndex(
        (_event) => _event.id === arg.event.id,
    )
    state.collaboratorEvents[index].title = `${Math.abs(
        (arg.event.end - arg.event.start) / 36e5,
    )}h ${state.collaboratorEvents[index].hourTypology}`
    state.collaboratorEvents[index].start = arg.event.startStr
    state.collaboratorEvents[index].end = arg.event.endStr
  },
  RESIZE_EVENT_COLLABORATOR(state, arg) {
    const index = state.collaboratorEvents.findIndex((_event) => {
      return _event.id === arg.event.id
    })
    state.collaboratorEvents[index].title = `${Math.abs(
        (arg.event.end - arg.event.start) / 36e5,
    )}h ${state.collaboratorEvents[index].hourTypology}`
    state.collaboratorEvents[index].start = arg.event.startStr
    state.collaboratorEvents[index].end = arg.event.endStr
  },
  ORDER_COLLABORATOR_EVENTS(state) {
    state.collaboratorEvents.sort(
        (a, b) => new Date(a.start) - new Date(b.start),
    )
  },
  TOGGLE_CALENDAR_LOADING(state, status) {
    state.calendarLoading = status
  },
  UPDATE_TEAM_WEEK_PLANNING_EVENTS(state, teamWeekPlanning) {
    state.teamWeekPlanningEvents =
      formatTeamWeekPlanningEvents(teamWeekPlanning)
  },
}

export const actions = {
  // HOUR TYPOLOGY
  // GET
  async fetchHourTypologyAction(store, uuid) {
    try {
      const res = await axios.get(
        `${BASE}/mx/planning/api/v2/hourTypologies/${uuid}`,
      )
      store.commit('UPDATE_HOUR_TYPOLOGY', res.data)
    } catch (error) {
      throw new Error(
        'API Error occurred in /mx/planning/api/v2/hourTypologies.',
      )
    }
  },
  // HOUR TYPOLOGIES
  // GET
  async fetchHourTypologiesAction(store) {
    const hourTypologiesFromLS = JSON.parse(
        localStorage.getItem('hourTypologies'),
    )
    if (!hourTypologiesFromLS) {
      try {
        store.commit('UPDATE_HOUR_TYPOLOGIES', [])
        const res = await axios.get(`${BASE}/mx/planning/api/v2/hourTypologies`)
        store.commit('UPDATE_HOUR_TYPOLOGIES', res.data)
      } catch (error) {
        throw new Error(
            'API Error occurred in /mx/planning/api/v2/hourTypologies.',
        )
      }
    }
  },
  // HOUR TYPOLOGIES
  // GET
  async fetchHourTypologiesByCollaboratorAction(store, collaboratorUuid) {
    const hourTypologiesFromLS = JSON.parse(
        localStorage.getItem('hourTypologies'),
    )
    if (!hourTypologiesFromLS) {
      try {
        store.commit('UPDATE_HOUR_TYPOLOGIES', [])
        const res = await axios.get(
            `${BASE}/mx/planning/api/v2/PlanningManager/hourTypologyByCollaborator?filter[collaboratorUuid]=${collaboratorUuid}`,
        )
        store.commit('UPDATE_HOUR_TYPOLOGIES', res.data)
      } catch (error) {
        throw new Error(
            'API Error occurred in /mx/planning/api/v2/PlanningManager/hourTypologyByCollaborator.',
        )
      }
    }
  },
  // TEMPLATE HOUR TYPOLOGIES
  // GET
  async fetchTemplateHourTypologiesAction(store) {
    // @fixme: this assumes that hour typologies will never change in the database.
    const hourTypologiesPlanningTemplateFromLS = JSON.parse(
        localStorage.getItem('hourTypologiesPlanningTemplate'),
    )
    if (!hourTypologiesPlanningTemplateFromLS) {
      try {
        store.commit('UPDATE_HOUR_TYPOLOGIES_PLANNING_TEMPLATE', [])
        const res = await axios.get(
            `${BASE}/mx/planning/api/v2/hourTypologies/planningTemplate`,
        )
        store.commit('UPDATE_HOUR_TYPOLOGIES_PLANNING_TEMPLATE', res.data)
      } catch (error) {
        throw new Error(
            'API Error occurred in /mx/planning/api/v2/hourTypologies/planningTemplate.',
        )
      }
    }
  },

  // PLANNING RULE
  // GET
  async fetchPlanningRuleAction(store, uuid) {
    try {
      const res = await axios.get(
        `${BASE}/mx/planning/api/v2/planningRules/${uuid}`,
      )
      store.commit('UPDATE_PLANNING_RULE', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in /mx/planning/api/v2/planningRules/${uuid}.`,
      )
    }
  },
  // PLANNING RULES
  // GET
  async fetchPlanningRulesAction(store) {
    try {
      const res = await axios.get(`${BASE}/mx/planning/api/v2/planningRules`)
      store.commit('UPDATE_PLANNING_RULES', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in /mx/planning/api/v2/planningRules.${error}`,
      )
    }
  },
  // GROUPING TYPE
  // GET
  async fetchGroupingTypeAction(store, uuid) {
    try {
      const res = await axios.get(
        `${BASE}/mx/planning/api/v2/groupingTypes/${uuid}`,
      )
      store.commit('UPDATE_PLANNING_GROUPING_TYPE', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in /planning/api/v2/groupingTypes/${uuid}.`,
      )
    }
  },
  // GROUPING TYPES
  // GET
  async fetchGroupingTypesAction(store) {
    try {
      const res = await axios.get(`${BASE}/mx/planning/api/v2/groupingTypes`)
      store.commit('UPDATE_PLANNING_GROUPING_TYPES', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in /planning/api/v2/groupingTypes.`)
    }
  },

  // SITE CEX
  // GET
  async fetchSiteCexAction(store, sitePersonnelDivision) {
    try {
      const res = await axios.get(
        `${BASE}/mx/planning/api/v2/siteCEX/${sitePersonnelDivision}`,
      )
      store.commit('UPDATE_SITE_CEX', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in /mx/planning/api/v2/siteCEX/${sitePersonnelDivision}.`,
      )
    }
  },
  // HOUR PARENTS
  // GET
  async fetchHourParentsAction(store) {
    try {
      const res = await axios.get(`${BASE}/mx/planning/api/v2/hourParents`)
      store.commit('UPDATE_HOUR_PARENTS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in /mx/planning/api/v2/hourParents.`)
    }
  },

  // PLANNING TEMPLATE
  // GET
  async fetchPlanningTemplateAction(store, teamUuid) {
    try {
      store.commit('UPDATE_PLANNING_TEMPLATE', [])
      store.commit('UPDATE_PLANNING_TEMPLATE_PERIODS', [])
      const res = await axios.get(
          `${BASE}/mx/planning/api/v2/planningTemplates/${teamUuid}`,
      )
      store.commit('UPDATE_PLANNING_TEMPLATE', res.data)
      store.commit('UPDATE_PLANNING_TEMPLATE_PERIODS', res.data)
    } catch (error) {
      throw new Error(
          `API Error occurred in ${BASE}/mx/planning/api/v2/planningTemplates/${teamUuid}`,
      )
    }
  },
  // TEAM WEEK PLANNING
  // GET
  async fetchTeamWeekPlanningAction(store, filters) {
    const { date, teamUuid } = filters
    try {
      const res = await axios.get(
        `${BASE}/planning/api/v2/planning/weekTeam?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}`,
      )
      store.commit('UPDATE_TEAM_WEEK_PLANNING', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/planning/api/v2/planning/weekTeam?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}: ${error}`,
      )
    }
  },
  // TEAM WEEK PLANNING
  // GET
  async fetchCollaboratorTeamWeekPlanningAction(store, filters) {
    const { date } = filters
    try {
      const res = await axios.get(
        `${BASE}/mx/planning/api/v2/planning/collaboratorWeekTeam?filter[startDateInterval]=${date}`,
      )
      store.commit('UPDATE_COLLABORATOR_TEAM_WEEK_PLANNING', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/planning/api/v2/planning/collaboratorWeekTeam?filter[startDateInterval]=${date}: ${error}`,
      )
    }
  },
  // TEAM WEEK PLANNING BY MANAGER
  // GET
  async fetchTeamWeekPlanningByManagerAction(store, filters) {
    store.commit('TOGGLE_CALENDAR_LOADING', true)
    store.commit('UPDATE_TEAM_WEEK_PLANNING_EVENTS', [])
    const { date, teamUuid, biweekly, endDate } = filters
    try {
      let res = null
      if (biweekly) {
        res = await axios.get(
            `${BASE}/mx/planning/api/v2/planning/weekTeamByManager?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}&filter[biweekly]=${biweekly}`,
        )
      } else {
        res = await axios.get(

          `${BASE}/mx/planning/api/v2/planning/weekTeamByManager?filter[startDateInterval]=${date}&filter[endDateInterval]=${endDate}&filter[teamUuid]=${teamUuid}`,
        )
      }
      store.commit('UPDATE_TEAM_WEEK_PLANNING_EVENTS', res.data)
      store.commit('TOGGLE_CALENDAR_LOADING', false)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/planning/api/v2/planning/weekTeamByManager?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}: ${error}`,
      )
    }
  },
  // SITE WEEK PLANNING BY MANAGER
  // GET
  async fetchSiteWeekPlanningByManagerAction(store, filters) {
    store.commit('TOGGLE_CALENDAR_LOADING', true)
    store.commit('UPDATE_TEAM_WEEK_PLANNING_EVENTS', [])
    const { date, teamUuid, biweekly } = filters
    try {
      let res = null
      if (biweekly) {
        res = await axios.get(
            `${BASE}/mx/planning/api/v2/planning/weekSiteByManager?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}&filter[biweekly]=${biweekly}`,
        )
      } else {
        res = await axios.get(

            `${BASE}/mx/planning/api/v2/planning/weekSiteByManager?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}`,
        )
      }
      store.commit('UPDATE_TEAM_WEEK_PLANNING_EVENTS', res.data)
      store.commit('TOGGLE_CALENDAR_LOADING', false)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/planning/api/v2/planning/weekSiteByManager?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}: ${error}`,
      )
    }
  },
  // WEEKLY NOTIFICATIONS COLLABORATOR
  // GET
  async fetchCollaboratorPendingWeeklyNotifications(store) {
    store.commit('UPDATE_COLLABORATOR_PENDING_WEEKLY_NOTIFICATIONS', [])
    const url = `${BASE}/mx/planning/api/notifications/pendingWeeklyNotificationsByCollaborator`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_COLLABORATOR_PENDING_WEEKLY_NOTIFICATIONS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // RESET PENDING NOTIFICATION (FOR COLLABORATOR ROLE)
  // GET
  async resetPendingQuarterlyNotificationCollaboratorState({ commit }) {
    try {
      await commit('RESET_PENDING_QUARTERLY_NOTIFICATION_FOR_COLLABORATOR')
    } catch (error) {
      throw new Error(
        `API Error occurred in resetPendingQuarterlyNotificationCollaboratorState: ${error}`,
      )
    }
  },
  // QUARTERLY PENDING NOTIFICATION (FOR COLLABORATOR ROLE)
  // GET
  async fetchPendingQuarterlyNotificationCollaboratorAction(
    { commit },
    payload,
  ) {
    const { year, quarter } = payload
    const url = `${BASE}/mx/planning/api/notifications/quarterlyByCollaborator?filter[year]=${year}&filter[quarter]=${quarter}`
    try {
      // commit('UPDATE_PENDING_QUARTERLY_NOTIFICATION_FOR_COLLABORATOR', [])
      const response = await axios.get(url)
      if (response.data.length > 0)
        commit(
          'UPDATE_PENDING_QUARTERLY_NOTIFICATION_FOR_COLLABORATOR',
          response.data[0],
        )
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // VIEW PLANNINGS RELATED TO QUARTERLY NOTIFICATION (FOR COLLABORATOR ROLE)
  // POST

  async viewQuarterlyNotificationByCollaboratorAction({ commit }, payload) {
    try {
      commit('UPDATE_QUARTERLY_NOTIFICATIONS_BY_COLLABORATOR', {
        proposals: [],
      })
      const res = await axios.post(
          `${BASE}/mx/planning/api/notifications/viewQuarterlyByCollaborator`,
          payload,
      )
      if (res.data.success) {
        commit(
            'UPDATE_QUARTERLY_NOTIFICATIONS_BY_COLLABORATOR',
            res.data.aggregates,
        )
      }
      return res
    } catch (error) {
      throw new Error(
          `API Error occurred in /mx/planning/api/notifications/viewQuarterlyByCollaborator: ${error}`,
      )
    }
  },

  // WEEK PLANNING BY COLLABORATOR
  // GET
  async fetchWeekPlanningByCollaboratorAction(store) {
    store.commit('UPDATE_COLLABORATOR_WEEK_PLANNING', null)
    try {
      const res = await axios.get(
        `${BASE}/mx/planning/api/v2/planning/collaboratorWeek`,
      )
      store.commit('UPDATE_COLLABORATOR_WEEK_PLANNING', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/planning/api/v2/planning/collaboratorWeek: ${error}`,
      )
    }
  },
  // TEAM WEEK MODIFICATION PROPOSAL
  // GET
  async fetchTeamWeekModificationProposalAction(store, filters) {
    const { date, teamUuid } = filters
    const url = `${BASE}/mx/planning/api/v2/modificationProposal/weekTeam?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_TEAM_WEEK_MODIFICATION_PROPOSAL', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
  // COLLABORATOR PAST MONTH PLANNING
  // GET
  async fetchPastCollaboratorMonthPlanningAction(store, filters) {
    store.commit('UPDATE_COLLABORATOR_MONTH_PLANNING_MANAGER', [])
    const { monthStartDate, collaboratorUuid } = filters
    try {
      const res = await axios.get(
          `${BASE}/mx/planning/api/v2/PlanningManager/pastMonthCollaboratorPlanning?filter[month]=${monthStartDate}&filter[collaboratorUuid]=${collaboratorUuid}`,
      )
      store.commit('UPDATE_COLLABORATOR_MONTH_PLANNING_MANAGER', res.data.collaboratorPeriods)
      store.commit('UPDATE_COLLABORATOR_BASIC_DATA', res.data.collaboratorData)
    } catch (error) {
      throw new Error(
          `API Error occurred in ${BASE}/mx/planning/api/v2/PlanningManager/pastMonthCollaboratorPlanning?filter[month]=${monthStartDate}&filter[collaboratorUuid]=${collaboratorUuid}: ${error}`,
      )
    }
  },
  // COLLABORATOR MONTH PLANNING
  // GET
  async fetchCollaboratorMonthPlanningAction(store, filters) {
    store.commit('UPDATE_COLLABORATOR_MONTH_PLANNING_MANAGER', [])
    store.commit('UPDATE_COLLABORATOR_BASIC_DATA', null)
    const { monthStartDate, collaboratorUuid } = filters
    const url = `${BASE}/mx/planning/api/v2/PlanningManager/monthlyCollaboratorPlanning?filter[month]=${monthStartDate}&filter[collaboratorUuid]=${collaboratorUuid}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_COLLABORATOR_MONTH_PLANNING_MANAGER', res.data.collaboratorPeriods)
      store.commit('UPDATE_COLLABORATOR_BASIC_DATA', res.data.collaboratorData)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
  // COLLABORATOR MONTH OWN
  // GET
  async fetchCollaboratorOwnMonthPlanningAction(store, filters) {
    store.commit('UPDATE_COLLABORATOR_MONTH_PLANNING', [])
    store.commit('UPDATE_COLLABORATOR_BASIC_DATA', null)
    const { monthStartDate, collaboratorUuid } = filters
    try {
      const res = await axios.get(
          `${BASE}/mx/planning/api/v2/PlanningManager/monthlyCollaboratorPlanning?filter[month]=${monthStartDate}&filter[collaboratorUuid]=${collaboratorUuid}`,
      )
      store.commit('UPDATE_COLLABORATOR_MONTH_PLANNING', res.data.collaboratorPeriods)
      store.commit('UPDATE_COLLABORATOR_BASIC_DATA', res.data.collaboratorData)
    } catch (error) {
      throw new Error(
          `API Error occurred in ${BASE}/mx/planning/api/v2/PlanningManager/monthlyCollaboratorPlanning?filter[month]=${monthStartDate}&filter[collaboratorUuid]=${collaboratorUuid}: ${error}`,
      )
    }
  },
  // COLLABORATOR MONTH PLANNING BY MANAGER
  // GET
  async fetchCollaboratorMonthPlanningByManagerAction(store, filters) {
    store.commit('UPDATE_COLLABORATOR_MONTH_PLANNING', [])
    const { monthStartDate, collaboratorUuid } = filters
    try {
      const res = await axios.get(
          `${BASE}/mx/planning/api/v2/planning/collaboratorMonthlyPlanningByManagerProfile?filter[date]=${monthStartDate}&filter[collaboratorUuid]=${collaboratorUuid}`,
      )
      store.commit('UPDATE_COLLABORATOR_MONTH_PLANNING', res.data.collaboratorPeriods)
    } catch (error) {
      throw new Error(
          `API Error occurred in ${BASE}/mx/planning/api/v2/planning/collaboratorMonthlyPlanningByManagerProfile?filter[date]=${monthStartDate}&filter[collaboratorUuid]=${collaboratorUuid}: ${error}`,
      )
    }
  },
  // WEEKS
  // GET
  async fetchWeeksForTemplateManagementAction(store, filters) {
    store.commit('UPDATE_TEMPLATE_MANAGEMENT_WEEKS', null)
    const { date, teamUuid } = filters
    const url = `${BASE}/mx/planning/api/v2/planningModifications/weeks?filter[startDateInterval]=${date}&filter[teamUuid]=${teamUuid}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_TEMPLATE_MANAGEMENT_WEEKS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}`)
    }
  },
  // SITE QUARTERLY NOTIFICATIONS
  // GET
  async fetchSiteQuarterlyNotificationsAction(store, filters) {
    store.commit('UPDATE_SITE_QUARTERLY_NOTIFICATIONS', null)
    const { personnelDivision, year, quarter } = filters
    try {
      const res = await axios.get(
          `${BASE}/mx/planning/api/v2/quarterlyNotification/site/${personnelDivision}/${year}/${quarter}`,
      )
      store.commit('UPDATE_SITE_QUARTERLY_NOTIFICATIONS', res.data)
    } catch (error) {
      throw new Error(
          `API Error occurred in /mx/planning/api/v2/quarterlyNotification/site/${personnelDivision}/${year}/${quarter}: ${error}`,
      )
    }
  },
  // TEAM QUARTERLY NOTIFICATIONS
  // GET
  async fetchTeamQuarterlyNotificationsAction(store, filters) {
    store.commit('UPDATE_TEAM_QUARTERLY_NOTIFICATIONS', null)
    const { teamUuid, year, quarter } = filters
    try {
      const res = await axios.get(
          `${BASE}/mx/planning/api/v2/quarterlyNotification/team/${teamUuid}/${year}/${quarter}`,
      )
      store.commit('UPDATE_TEAM_QUARTERLY_NOTIFICATIONS', res.data)
    } catch (error) {
      throw new Error(
          `API Error occurred in /mx/planning/api/v2/quarterlyNotification/team/${teamUuid}/${year}/${quarter}: ${error}`,
      )
    }
  },

  // COLLABORATORS WITH PENDING QUARTERLY NOTIFICATIONS
  // GET
  async fetchCollaboratorsWithPendingNotificationsAction(store, filters) {
    const { personnelDivision, year, quarter } = filters
    try {
      const res = await axios.get(
        `${BASE}/planning/api/v2/quarterlyNotification/openStatus/actor/${personnelDivision}/${year}/${quarter}`,
      )
      store.commit('UPDATE_COLLABORATORS_WITH_PENDING_NOTIFICATIONS', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in /planning/api/v2/quarterlyNotification/openStatus/actor/${personnelDivision}/${year}/${quarter}: ${error}`,
      )
    }
  },

  // WEEKLY NOTIFICATIONS
  // GET
  async fetchWeeklyNotificationsAction(store, filters) {
    const filtersArr = []
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersArr.push(`filter[${key}]=${filters[key]}`)
      }
    })
    const queryString = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
    const url = `${BASE}/mx/planning/api/notifications/weeklyNotificationsInQuarter${queryString}`

    try {
      const res = await axios.get(url)
      store.commit('UPDATE_WEEKLY_NOTIFICATIONS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
  // OPEN WEEKLY NOTIFICATIONS
  // GET
  async fetchOpenWeeklyNotificationsAction(store, filters) {
    store.commit('UPDATE_WEEKLY_NOTIFICATIONS', [])
    const filtersArr = []
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersArr.push(`filter[${key}]=${filters[key]}`)
      }
    })
    const queryString = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
    const url = `${BASE}/mx/planning/api/notifications/openWeeklyNotificationsInQuarter${queryString}`

    try {
      const res = await axios.get(url)
      store.commit('UPDATE_WEEKLY_NOTIFICATIONS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // PENDING WEEKLY NOTIFICATIONS
  // GET
  async fetchManagedWeeklyNotificationsAction(store, filters) {
    store.commit('UPDATE_MANAGED_WEEKLY_NOTIFICATIONS', [])
    const filtersArr = []
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersArr.push(`filter[${key}]=${filters[key]}`)
      }
    })
    const queryString = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
    const url = `${BASE}/mx/planning/api/notifications/managedWeeklyNotificationsInQuarter${queryString}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_MANAGED_WEEKLY_NOTIFICATIONS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
  // LEGAL ERRORS
  // GET
  async fetchLegalErrorsAction(store, filters) {
    const filtersArr = []
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersArr.push(`filter[${key}]=${filters[key]}`)
      }
    })
    const queryString = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
    const url = `${BASE}/mx/planning/api/v2/PlanningManager/legalPlanningErrors/${queryString}`

    try {
      const res = await axios.get(url)
      store.commit('UPDATE_LEGAL_ERRORS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // /////////////
  // POST
  // /////////////

  // HOUR TYPOLOGY CREATE
  // POST
  async hourTypologyCreateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/hourTypologies/create.hourTypology`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/hourTypologies/create.hourTypology`,
      )
    }
  },
  // HOUR TYPOLOGY UPDATE
  // POST
  async hourTypologyUpdateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/hourTypologies/edit.hourTypology`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/hourTypologies/edit.hourTypology`,
      )
    }
  },
  // PLANNING RULE CREATE
  // POST
  async planningRuleCreateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/planningRules/create.planningRule`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/planningRules/create.planningRule`,
      )
    }
  },
  // PLANNING RULE UPDATE
  // POST
  async planningRuleUpdateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/planningRules/edit.planningRule`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/planningRules/edit.planningRule`,
      )
    }
  },
  // PLANNING RULE DELETE
  // POST
  async planningRuleDeleteAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/planningRules/delete.planningRule`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/planningRules/delete.planningRule`,
      )
    }
  },
  // GROUPING TYPE CREATE
  // POST
  async groupingTypeCreateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/groupingTypes/create.groupingType`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /planning/api/v2/groupingTypes/create.groupingType`,
      )
    }
  },
  // GROUPING TYPE UPDATE
  // POST
  async groupingTypeUpdateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/groupingTypes/edit.groupingType`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /planning/api/v2/groupingTypes/edit.groupingType`,
      )
    }
  },
  // GROUPING TYPE DELETE
  // POST
  async groupingTypeDeleteAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/groupingTypes/delete.groupingType`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /planning/api/v2/groupingTypes/delete.groupingType`,
      )
    }
  },
  // SITE CEX CREATE
  // POST
  async siteCexCreateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/siteCEX/create.siteCEX`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/siteCEX/create.siteCEX`,
      )
    }
  },
  // SITE CEX UPDATE
  // POST
  async siteCexUpdateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/siteCEX/edit.siteCEX`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/siteCEX/edit.siteCEX`,
      )
    }
  },
  // PLANNING TEMPLATE CREATE
  // POST
  async planningTemplateCreateAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/planningTemplates/create.planningTemplate`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/planningTemplates/create.planningTemplate`,
      )
    }
  },
  // PLANNING TEMPLATE DELETE
  // POST
  async planningTemplateDeleteAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/planningTemplates/delete.planningTemplate`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/planningTemplates/delete.planningTemplate`,
      )
    }
  },
  // PLANNING TEMPLATE COPY IN WEEKS
  // POST
  async planningTemplateCopyAction({ store }, payload) {
    const url = `${BASE}/mx/planning/api/v2/planningModifications/createFromTemplate`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ${url}`)
    }
  },
  // ERASE WEEK PLANNING
  // POST
  async eraseWeekPlanningAction({ store }, payload) {
    const url = `${BASE}/mx/planning/api/v2/planningModifications/delete`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ${url}`)
    }
  },
  // SEND QUARTERLY NOTIFICATION COLLABORATOR
  // POST
  async sendCollaboratorQuarterlyNotificationAction({ store }, payload) {
    try {
      return await axios.post(
          `${BASE}/mx/planning/api/v2/quarterlyNotification/sendCollaborator`,
          payload,
      )
    } catch (error) {
      throw Error(
          `API Error occurred at /planning/api/v2/quarterlyNotification/sendCollaborator: ${error}`,
      )
    }
  },
  // SEND QUARTERLY NOTIFICATION SITE
  // POST
  async sendSiteQuarterlyNotificationAction({ store }, payload) {
    try {
      return await axios.post(
          `${BASE}/mx/planning/api/v2/quarterlyNotification/sendSite`,
          payload,
      )
    } catch (error) {
      throw Error(
          `API Error occurred at /mx/planning/api/v2/quarterlyNotification/sendSite: ${error}`,
      )
    }
  },
  // SEND QUARTERLY NOTIFICATION TEAM
  // POST
  async sendTeamQuarterlyNotificationAction({ store }, payload) {
    try {
      return await axios.post(
          `${BASE}/mx/planning/api/v2/quarterlyNotification/sendTeam`,
          payload,
      )
    } catch (error) {
      throw Error(
          `API Error occurred at /mx/planning/api/v2/quarterlyNotification/sendTeam: ${error}`,
      )
    }
  },
  // SIGN ON PAPER QUARTERLY NOTIFICATION
  // POST
  async signOnPaperQuarterlyNotificationAction({ commit }, payload) {
    try {
      const res = await axios.post(
          `${BASE}/mx/planning/api/v2/quarterlyNotification/signOnPaper`,
          payload,
      )
      commit('UPDATE_SIGNED_QUARTERLY_NOTIFICATION', res.data.aggregates.data)
      commit(
          'UPDATE_QUARTERLY_NOTIFICATIONS_SIGN_DATE',
          res.data.aggregates.signAt,
      )
      return res
    } catch (error) {
      throw Error(
          `API Error occurred at /mx/planning/api/v2/quarterlyNotification/signOnPaper: ${error}`,
      )
    }
  },
  // VIEW SIGN QUARTERLY NOTIFICATION DOCUMENT
  // POST
  async viewSignedQuarterlyNotificationAction({ commit }, payload) {
    try {
      commit('UPDATE_SIGNED_QUARTERLY_NOTIFICATION', [])
      commit('UPDATE_QUARTERLY_NOTIFICATIONS_SIGN_DATE', null)
      const res = await axios.post(
          `${BASE}/mx/planning/api/v2/quarterlyNotification/viewSignOnPaperQuarterlyNotification`,
          payload,
      )
      commit('UPDATE_SIGNED_QUARTERLY_NOTIFICATION', res.data.aggregates.data)
      commit(
          'UPDATE_QUARTERLY_NOTIFICATIONS_SIGN_DATE',
          res.data.aggregates.signAt,
      )
    } catch (error) {
      throw new Error(
          `API Error occurred in /mx/planning/api/v2/quarterlyNotification/viewSignOnPaperQuarterlyNotification: ${error}`,
      )
    }
  },
  // SEND WEEKLY NOTIFICATION SITE
  // POST
  async sendWeeklyNotificationAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/notifications/sendWeeklyNotification`,
        payload,
      )
    } catch (error) {
      throw Error(
        `API Error occurred at /planning/api/v2/weeklyNotification/send: ${error}`,
      )
    }
  },
  // SEND MULTIPLE WEEKLY NOTIFICATION SITE
  // POST
  async sendMultipleWeeklyNotificationAction({ store }, payload) {
    try {
      return await axios.post(
          `${BASE}/mx/planning/api/notifications/sendWeeklyNotification`,
          payload,
      )
    } catch (error) {
      throw Error(
          `API Error occurred at /planning/api/v2/weeklyNotification/send: ${error}`,
      )
    }
  },
  // ACCEPT WEEKLY NOTIFICATION
  // POST
  async acceptWeeklyNotificationAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/notifications/acceptWeeklyNotification`,
        payload,
      )
    } catch (error) {
      throw Error(
        `API Error occurred at /planning/api/v2/weeklyNotification/accept: ${error}`,
      )
    }
  },
  // CLOSE WEEKLY NOTIFICATION
  // POST
  async closeWeeklyNotificationAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/notifications/closeWeeklyNotification`,
        payload,
      )
    } catch (error) {
      throw Error(
        `API Error occurred at /planning/api/v2/weeklyNotification/close: ${error}`,
      )
    }
  },
  // GET PLANNING DIFFERENCES BY NOTIFICATION UUID
  // POST
  async fetchPlanningDifferencesByNotification(store, payload) {
    const url = `${BASE}/mx/planning/api/v2/planningModifications/differencesByNotification`
    try {
      store.commit(
          'UPDATE_COLLABORATOR_WEEK_PLANNING_MODIFICATION_DIFFERENCES',
          [],
      )
      const res = await axios.post(url, payload)
      store.commit('UPDATE_COLLABORATOR_PLANNING_DIFFERENCES', res.data.data)
      // store.commit(
      //   'UPDATE_COLLABORATOR_WEEK_PLANNING_MODIFICATION_DIFFERENCES',
      //   res.data.data.differences,
      // )
      return res
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
  // COPY PLANNING
  // POST
  async copyPlanningAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/PlanningManager/copyPlanningFromCollaboratorToAnother`,
        payload,
      )
    } catch (error) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/PlanningManager/copyPlanningFromCollaboratorToAnother: ${error}`,
      )
    }
  },
  // SAVE TEAM WEEK PLANNING
  // POST
  async saveTeamWeekPlanningAction({ store }, payload) {
    const url = `${BASE}/mx/planning/api/v2/planningModifications/modificationProposal/create.weekTeam`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ${url}: ${e}`)
    }
  },
  // SAVE COLLABORATOR MONTH PLANNING
  // POST
  /**
   * @deprecated
   * @param store
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async saveCollaboratorMonthPlanningAction({ store }, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/planning/api/v2/PlanningManager/createCollaboratorWeek`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/planning/api/v2/PlanningManager/createCollaboratorWeek: ${e}`,
      )
    }
  },
  // VIEW COLLABORATOR QUARTERLY NOTIFICATION
  // POST
  async viewCollaboratorQuarterlyNotificationAction({ commit }, payload) {
    try {
      const res = await axios.post(
        `${BASE}/planning/api/v2/quarterlyNotification/viewQuarterlyNotification`,
        payload,
      )
      commit(
        'UPDATE_COLLABORATOR_QUARTERLY_NOTIFICATIONS',
        res.data.aggregates.data,
      )
    } catch (error) {
      throw new Error(
        `API Error occurred in /planning/api/v2/quarterlyNotification/viewQuarterlyNotification: ${error}`,
      )
    }
  },
  // CHECK IDENTIFICATION DOCUMENT VALIDATION (DOBLE FACTOR VERIFICATION TO ACCEPT/REJECT A PURPOSED PLANNING)
  // GET
  async checkIdentificationDocumentVerificationAction(
      { commit },
      identificationNumber,
  ) {
    const filter = `?filter[identificationDocument]=${identificationNumber}`
    const url = `${BASE}/mx/api/v2/identificationDocumentVerification${filter}`
    try {
      const res = await axios.get(url)
      return res.data.result
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
  // ACCEPT COLLABORATOR COMMUNICATED WEEKLY NOTIFICATION ACTION
  async acceptCollaboratorWeeklyNotificationAction({ commit }, payload) {
    const url = `${BASE}/mx/planning/api/notifications/acceptWeeklyNotificationByCollaborator`
    try {
      const res = await axios.post(url, payload)
      return res
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // REJECT COLLABORATOR COMMUNICATED WEEKLY NOTIFICATION ACTION
  async rejectCollaboratorWeeklyNotificationAction({ commit }, payload) {
    const url = `${BASE}/mx/planning/api/notifications/rejectWeeklyNotificationByCollaborator`
    try {
      const res = await axios.post(url, payload)
      return res
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
  // VIEW COLLABORATOR WEEKLY NOTIFICATION
  // POST
  async viewCollaboratorWeeklyNotificationAction({ commit }, payload) {
    try {
      const res = await axios.post(
        `${BASE}/planning/api/v2/weeklyNotification/viewWeeklyNotification`,
        payload,
      )
      commit(
        'UPDATE_COLLABORATOR_WEEKLY_NOTIFICATIONS',
        res.data.aggregates.data,
      )
    } catch (error) {
      throw new Error(
        `API Error occurred in /planning/api/v2/weeklyNotification/viewWeeklyNotification: ${error}`,
      )
    }
  },

  // SITE TIME SLOTS INTERVALS - FETCH defaultTimeSlots
  // GET
  async fetchDefaultTimeSlotsAction(store, filters) {
    store.commit('UPDATE_DEFAULT_TIME_SLOTS', [])
    const url = `${BASE}/mx/planning/api/v2/planning/defaultTimeSlots`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_DEFAULT_TIME_SLOTS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
  // SITE TIME SLOTS INTERVALS - FETCH siteTimeSlotsIntervals
  // GET
  async fetchSiteTimeSlotsIntervalsAction(store, filters) {
    const { personnelDivision } = filters
    store.commit('UPDATE_SITE_TIME_SLOTS_INTERVALS', [])
    const url = `${BASE}/mx/planning/api/v2/planning/siteTimeSlotIntervals/${personnelDivision}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_SITE_TIME_SLOTS_INTERVALS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // SITE TIME SLOTS INTERVALS - FETCH specific siteTimeSlotsInterval by UUID
  // GET
  async fetchSiteTimeSlotsIntervalAction(store, filters) {
    const { uuid } = filters
    store.commit('UPDATE_SITE_TIME_SLOTS_INTERVAL', null)
    const url = `${BASE}/mx/planning/api/v2/planning/siteTimeSlotInterval/${uuid}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_SITE_TIME_SLOTS_INTERVAL', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // SITE TIME SLOTS INTERVALS - FETCH active time slots for given date and site
  // GET
  async fetchActiveSiteTimeSlotsAction(store, filters) {
    store.commit('UPDATE_ACTIVE_SITE_TIME_SLOTS', [])
    const queryString = queryStringFilterBuilder(filters)
    const url = `${BASE}/mx/planning/api/v2/planning/activeSiteTimeSlotsBySiteAndDate${queryString}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_ACTIVE_SITE_TIME_SLOTS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // SITE TIME SLOTS INTERVALS - CREATE site interval time slots
  // POST
  async createSiteTimeSlotsIntervalAction(store, payload) {
    const url = `${BASE}/mx/planning/api/v2/planning/siteTimeSlotIntervals`
    try {
      return await axios.post(url, payload)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // SITE TIME SLOTS INTERVALS - UPDATE site interval time slots
  // PUT
  async updateSiteTimeSlotsIntervalAction(store, payload) {
    const url = `${BASE}/mx/planning/api/v2/planning/siteTimeSlotIntervals`
    try {
      return await axios.put(url, payload)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },

  // SAVE WEEK FOR COLLABORATOR MONTH PLANNING
  // POST
  async saveWeekCollaboratorMonthPlanningAction({ store }, payload) {
    try {
      return await axios.post(
          `${BASE}/mx/planning/api/v2/PlanningManager/createCollaboratorWeek`,
          payload,
      )
    } catch (e) {
      throw Error(
          `API Error occurred at /mx/planning/api/v2/PlanningManager/createCollaboratorWeek: ${e}`,
      )
    }
  },
  // SAVE WEEK FOR PAST COLLABORATOR MONTH PLANNING
  // POST
  async saveWeekPastCollaboratorMonthPlanningAction({ store }, payload) {
    try {
      return await axios.post(
          `${BASE}/mx/planning/api/v2/PlanningManager/editWeekOfPastMonth`,
          payload,
      )
    } catch (e) {
      throw Error(
          `API Error occurred at /mx/planning/api/v2/PlanningManager/editWeekOfPastMonth: ${e}`,
      )
    }
  },
}

// ///////////
// HELPER FUNCTIONS
// //////////

function getTemplateEventToUpdate(state, event) {
  const eventIndex = state.planningTemplatePeriods.findIndex(
    (e) => e.id === event.id,
  )
  return state.planningTemplatePeriods[eventIndex]
}

function formatTemplatePeriods(planningTemplate) {
  return planningTemplate
    .map((e) => {
      return e.planningTemplatePeriodsDto
    })
    .flat()
    .map((period) => {
      return {
        id: period.uuid,
        resourceId: period.collaboratorUuid,
        start: period.fromHour,
        end: period.toHour,
        overlap: false,
        hourTypologyUuid: period.hourTypologyUuid,
        color: period.color,
        hourTypology: period.abbreviation,
        workDay: period.dayOfWeek,
      }
    })
}
function formatModificationProposal(teamWeekModificationProposal) {
  return teamWeekModificationProposal.map((period) => {
    return {
      id: period.planningModificationPeriodUuid,
      resourceId: period.collaboratorUuid,
      title: `${
        ((new Date(period.toHour) - new Date(period.fromHour)) / 36e5) % 24
      }h ${period.hourTypology.abbreviation}`,
      start: new Date(period.fromHour),
      end: new Date(period.toHour),
      overlap: false,
      hourTypologyUuid: period.hourTypology.uuid,
      hourTypology: period.hourTypology.abbreviation,
      color: period.hourTypology.color,
      workDay: period.date,
    }
  })
}
function filterCollaboratorMonthPlanning(collaboratorMonthPlanning) {
  return collaboratorMonthPlanning.map((event) => {
    return {
      id: event.planningPeriodUuid,
      resourceId: event.collaboratorUuid,
      title: `${((event.toHour - event.fromHour) / 36e5) % 24}h ${
        event.translation
      }`,
      start: new Date(event.fromHour),
      end: new Date(event.toHour),
      hourTypologyUuid: event.hourTypologyUuid,
      hourTypology: event.translation,
      color: event.hourTypologyColor,
      workDay: event.fromHour,
    }
  })
}
function filterCollaboratorMonthPlanningManager(collaboratorMonthPlanning) {
  return collaboratorMonthPlanning.map((period) => {
    return {
      id: period.planningPeriodUuid,
      resourceId: period.collaboratorUuid,
      title: `${
          ((new Date(period.toHour) - new Date(period.fromHour)) / 36e5) % 24
      }h ${period.translation}`,
      start: period.fromHour,
      end: period.toHour,
      overlap: false,
      hourTypologyUuid: period.hourTypologyUuid,
      hourTypology: period.translation,
      color: period.hourTypologyColor,
      workDay: period.date,
    }
  })
}

function formatTeamWeekPlanningEvents(teamWeekPlanning) {
  return teamWeekPlanning.map((period) => {
    return {
      id: period.planningModificationPeriodUuid,
      resourceId: period.collaboratorUuid,
      title: `${
          ((new Date(period.toHour) - new Date(period.fromHour)) / 36e5) % 24
      }h ${period.hourTypology.abbreviation}`,
      start: period.fromHour,
      end: period.toHour,
      overlap: false,
      hourTypologyUuid: period.hourTypology.uuid,
      hourTypology: period.hourTypology.abbreviation,
      color: period.hourTypology.color,
      workDay: period.date,
    }
  })
}

function formatCollaboratorMonthPlanningEvents(collaboratorMonthPlanning) {
  return collaboratorMonthPlanning.map((period) => {
    return {
      id: period.planningPeriodUuid,
      resourceId: period.collaboratorUuid,
      title: `${
          ((new Date(period.toHour) - new Date(period.fromHour)) / 36e5) % 24
      }h ${period.translation}`,
      start: period.fromHour,
      end: period.toHour,
      overlap: false,
      hourTypologyUuid: period.hourTypologyUuid,
      hourTypology: period.translation,
      color: period.hourTypologyColor,
      workDay: period.date,
    }
  })
}

function formatCollaboratorWeekPlanningModificationDifferences(
    collaboratorWeekPlanningModificationDifferences,
) {
  return collaboratorWeekPlanningModificationDifferences.map(
      (dayEvents, dayIndex) => {
        return dayEvents.map((period, index) => {
          return {
            id: index,
            resourceId: 1,
            title: `${
                ((new Date(period.toHour) - new Date(period.fromHour)) / 36e5) % 24
            }h ${period.translation}`,
            start: period.fromHour,
            end: period.toHour,
            color: period.color,
            hourTypology: period.translation,
            action: period.action,
            workDay: period.date,
          }
        })
      },
  )
}
